
import { SelectItem } from "@shared/components/ui/select";

interface Experience {
  id: string;
  title: string;
}

interface ExperienceDropdownItemProps {
  experience: Experience;
  disabled?: boolean;
  isSoldOut?: boolean;
}

export const ExperienceDropdownItem = ({ 
  experience,
  disabled = false,
  isSoldOut = false 
}: ExperienceDropdownItemProps) => {
  const className = isSoldOut
    ? "opacity-50 cursor-not-allowed relative after:absolute after:right-4 after:top-1/2 after:-translate-y-1/2 after:content-['(Sold_out)'] after:text-sm after:text-foreground/50"
    : "";

  return (
    <SelectItem
      value={experience.id}
      disabled={disabled}
      className={className}
    >
      <span>{experience.title}</span>
    </SelectItem>
  );
};
